module.exports = __webpack_public_path__ + "static/img/calendar.eec864b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/calendar.jpg
// module id = a6k1
// module chunks = 1